import subject_icons from "../../utils/subject-icons";
import { formatDate } from "../../utils/dateUtils";
import { isNotEmptyOrNull } from "../../utils/common-utils";
import { stringConstants } from "../../utils/strings/StringConstants";
import LevelUp from "../../components/atoms/icons/levelUp.svg";
import Lottie from "react-lottie-player";
import AppreciationGif from "../../components/atoms/icons/appreciation.json";
import ProficientNew from "../../assets/svgs/proficientNew.svg";
import AdvancedNew from "../../assets/svgs/advancedNew.svg";
import ExperientialLearning from "../../assets/svgs/experientialTaskCard.svg";
import ReminderGif from "../../components/atoms/icons/reminder.json";
import CustomToolTip from "../../components/atoms/chakraHelpers/customToolTip";
import accordion_images from "../../utils/accordion/accordion_images";
import { Box, Image, Text, Tooltip } from "@chakra-ui/react";
import { useSpring, animated } from "@react-spring/web";

export const EmptyCardsTitle = (optionValue) => {
  switch (optionValue) {
    case "top_priority":
      return "You don't have any upcoming homework 🙂";
    case "missed_opportunity":
      return "No overdue homework 😃";
    case "completed":
      return "You haven't completed any homework yet 😐";
    default:
      return "You don't have any upcoming homework 🙂";
  }
};

export const EmptyCardsDescription = (optionValue) => {
  switch (optionValue) {
    case "top_priority":
      return "When your teacher assigns, you'll see them here";
    case "missed_opportunity":
      return "If any of the homework is not completed within the given due date, you'll see them here";
    case "completed":
      return "Once you complete a homework, you'll see it here";
    default:
      return "When your teacher assigns, you'll see them here";
  }
};

export const catagoryNames = (category) => {
  switch (category) {
    case "GuidedPractise":
      return "Guided Practice";
    case "LearnSubtopic":
      return "Learn";
    case "LearnPrerequisite":
      return "Prerequisite";
    case "Assessment":
      return "Assessment Practice";
    case "ExperientialLearning":
      return "Experiential Activity";
    default:
      return category;
  }
};

export const subjectIcons = (subject) => {
  switch (subject) {
    case "Biology":
      return subject_icons.biology;
    case "Physics":
      return subject_icons.physics;
    case "Maths":
    case "Mathematics":
      return subject_icons.maths;
    case "Social Science":
      return subject_icons.social;
    case "Chemistry":
      return subject_icons.chemistry;
    case "English":
      return subject_icons.english;
  }
};

export const subjectIconsMobile = (subject) => {
  switch (subject) {
    case "Biology":
      return subject_icons.bialogyMobile;
    case "Physics":
      return subject_icons.physicsMobile;
    case "Maths":
    case "Mathematics":
      return subject_icons.mathsMobile;
    case "Social Science":
      return subject_icons.socialMobile;
    case "Chemistry":
      return subject_icons.chemistryMobile;
    case "English":
      return subject_icons.englishMobile;
  }
};

export const checkTommorow = (completedOn, dueDate) => {
  const dueDateString = (
    isNotEmptyOrNull(completedOn) ? completedOn : dueDate
  ).split("T")[0];
  const formattedDueDate = new Date(dueDateString);
  const currentDate = new Date();
  const tomorrowDate = new Date();
  tomorrowDate.setDate(currentDate.getDate() + 1);
  if (
    formattedDueDate.getFullYear() === tomorrowDate.getFullYear() &&
    formattedDueDate.getMonth() === tomorrowDate.getMonth() &&
    formattedDueDate.getDate() === tomorrowDate.getDate()
  ) {
    return "Tomorrow";
  } else if (
    formattedDueDate.getFullYear() === currentDate.getFullYear() &&
    formattedDueDate.getMonth() === currentDate.getMonth() &&
    formattedDueDate.getDate() === currentDate.getDate()
  ) {
    return "Today";
  } else if (formattedDueDate < currentDate) {
    return formatDate(dueDateString);
  } else {
    return formatDate(dueDateString);
  }
};

export const getFormattedDate = (completedOn, dueDate) => {
  if (isNotEmptyOrNull(completedOn)) {
    return checkTommorow(completedOn, "");
  } else if (dueDate) {
    return checkTommorow("", dueDate);
  }
  return "";
};

export const getCreatedDate = (assignedDate) => {
  let result = "";
  result = formatDate(assignedDate, false);
  return result;
};

export const getBottomTitle = (
  isHover = false,
  levelUpNudge,
  appreciation,
  reminder,
  finishedDate,
  experientialLearning,
  levelUpReference,
  autoLevelUp,
  isCustomAssessment,
  isChapterEndAssessment,
  customSubtopicTaskNumber,
  createdDate,
  proficientLevel
) => {
  const hasLevelUpNudge = isNotEmptyOrNull(levelUpNudge) && levelUpNudge?.sent;
  const hasAppreciation = isNotEmptyOrNull(appreciation) && appreciation?.sent;
  const hasReminder = isNotEmptyOrNull(reminder) && reminder?.sent;

  let title;

  if (finishedDate === "completed") {
    if (hasAppreciation) {
      title = isHover
        ? stringConstants?.taskCardStrings?.completedAppreciationHoverText
        : stringConstants?.taskCardStrings?.completedAppreciationPlainText;
    } else if (hasLevelUpNudge) {
      title =
        levelUpNudge?.text ||
        stringConstants?.taskCardStrings?.completedPlainText;
    } else if (isNotEmptyOrNull(experientialLearning)) {
      title = isHover
        ? stringConstants?.taskCardStrings?.completedPlainText
        : stringConstants?.taskCardStrings?.completedPlainText;
    } else if (isNotEmptyOrNull(levelUpReference)) {
      if (autoLevelUp) {
        title = stringConstants?.taskCardStrings?.completedPlainText;
      } else {
        title = isHover
          ? stringConstants?.taskCardStrings?.completedPlainText
          : stringConstants?.taskCardStrings?.completedPlainText;
      }
    } else if (isCustomAssessment) {
      title = `${stringConstants?.taskCardStrings?.completedPlainText}`;
    } else if (isChapterEndAssessment) {
      title = `${stringConstants?.taskCardStrings?.completedPlainText}`;
    } else {
      title = stringConstants?.taskCardStrings?.completedPlainText;
    }
  } else if (hasReminder) {
    title = isHover
      ? stringConstants?.taskCardStrings?.reminderHoverText
      : `${stringConstants?.taskCardStrings?.reminderHoverText}`;
  } else if (isNotEmptyOrNull(levelUpReference)) {
    title = autoLevelUp
      ? stringConstants?.taskCardStrings?.pendingAutoLevelUpText
      : isHover
      ? stringConstants?.taskCardStrings?.reminderHoverText
      : stringConstants?.taskCardStrings?.pendingLevelUpReferencePlainText;
  } else if (isChapterEndAssessment) {
    title = ` ${stringConstants?.taskCardStrings?.chapterEndAssessmentTaskCard}`;
  } else if (isNotEmptyOrNull(experientialLearning)) {
    title = isHover
      ? stringConstants?.taskCardStrings?.pendingExperientialHoverText
      : stringConstants?.taskCardStrings?.pendingExperientialPlainText;
  } else if (isCustomAssessment) {
    title = `${stringConstants?.taskCardStrings?.pendingCustomAssessmentText}`;
  } else {
    title = `${stringConstants?.taskCardStrings?.pendingPlainText} ${createdDate}`;
  }

  return title || stringConstants?.taskCardStrings?.pendingPlainText;
};

export const LoadBottomText = (
  isHover,
  levelUpNudge,
  appreciation,
  reminder,
  finishedDate,
  experientialLearning,
  levelUpReference,
  autoLevelUp,
  isCustomAssessment,
  isChapterEndAssessment,
  customSubtopicTaskNumber,
  createdDate,
  proficientLevel,
  isMobile = false
) => {
  const bottomTitle = getBottomTitle(
    isHover,
    levelUpNudge,
    appreciation,
    reminder,
    finishedDate,
    experientialLearning,
    levelUpReference,
    autoLevelUp,
    isCustomAssessment,
    isChapterEndAssessment,
    customSubtopicTaskNumber,
    createdDate,
    proficientLevel
  );
  const parts = bottomTitle.split(/(levelup)/i);

  return (
    <Tooltip label={bottomTitle} placement="auto">
      <Text noOfLines={1} color={isMobile ? "#6D6BAE" : "purple.800"}>
        {parts.map((part, index) =>
          part.toLowerCase() === "levelup" ? (
            <Text as="span" fontWeight="bold" key={index}>
              Level up
            </Text>
          ) : (
            part
          )
        )}
      </Text>
    </Tooltip>
  );
};

export const getBottomIcon = (
  finishedDate,
  appreciation,
  experientialLearning,
  levelUpNudge,
  levelUpReference,
  autoLevelUp,
  isCustomAssessment,
  isChapterEndAssessment,
  proficientLevel,
  reminder,
  customSubtopicNames,
  isMobile = false
) => {
  const iconMap = {
    completed: {
      levelUpNudge: LevelUp,
      proficient: accordion_images?.chapterEndAssessmentTaskIcon,
      advanced: accordion_images?.chapterEndAssessmentTaskIcon,
      appreciation: AppreciationGif,
      experientialLearning: ExperientialLearning,
      customSubtopicInfo: accordion_images.customSubtopicInfoBlack,
      default: accordion_images.newTask,
    },
    default: {
      experientialLearning: ExperientialLearning,
      levelUpNudge: LevelUp,
      proficient: accordion_images?.chapterEndAssessmentTaskIcon,
      advanced: accordion_images?.chapterEndAssessmentTaskIcon,
      customSubtopicInfo: accordion_images.customSubtopicInfoBlack,
      reminder: ReminderGif,
      default: accordion_images.newTask,
    },
  };

  const iconKey = finishedDate === "completed" ? "completed" : "default";
  const subIconKey =
    finishedDate === "completed"
      ? isNotEmptyOrNull(appreciation) && appreciation?.sent
        ? "appreciation"
        : isCustomAssessment
        ? "customSubtopicInfo"
        : isNotEmptyOrNull(experientialLearning)
        ? "default"
        : (isNotEmptyOrNull(levelUpNudge) && levelUpNudge?.sent) ||
          isNotEmptyOrNull(levelUpReference) ||
          autoLevelUp
        ? "default"
        : isChapterEndAssessment
        ? proficientLevel.toLowerCase() === "proficient"
          ? "default"
          : proficientLevel.toLowerCase() === "advanced"
          ? "default"
          : "default"
        : "default"
      : isNotEmptyOrNull(reminder) && reminder?.sent
      ? "reminder"
      : (isChapterEndAssessment && isNotEmptyOrNull(levelUpReference)) ||
        autoLevelUp
      ? "levelUpNudge"
      : isChapterEndAssessment
      ? proficientLevel.toLowerCase() === "proficient"
        ? "proficient"
        : proficientLevel.toLowerCase() === "advanced"
        ? "advanced"
        : "default"
      : isNotEmptyOrNull(experientialLearning)
      ? "experientialLearning"
      : isNotEmptyOrNull(levelUpReference) || autoLevelUp
      ? "levelUpNudge"
      : isCustomAssessment
      ? "customSubtopicInfo"
      : "default";

  const iconSrc = iconMap[iconKey][subIconKey];

  if (subIconKey === "appreciation" || subIconKey === "reminder") {
    return (
      <Lottie
        loop
        animationData={iconSrc}
        play
        style={{
          width:
            isNotEmptyOrNull(appreciation) && appreciation?.sent
              ? "46px"
              : "24px",
          height: "24px",
        }}
      />
    );
  } else if (iconSrc) {
    return (
      <Box>
        {isCustomAssessment ? (
          <CustomToolTip
            data={customSubtopicNames}
            icon={iconSrc}
            variant={"TaskCard"}
          />
        ) : isMobile ? (
          <Image h="32px" w="32px" src={iconSrc} />
        ) : (
          <Image h="24px" w="24px" src={iconSrc} />
        )}
      </Box>
    );
  }
  return null;
};

export const AnimatedCount = ({ count }) => {
  const { number } = useSpring({
    from: { number: 0 },
    to: { number: count },
    config: { tension: 100, friction: 20 },
  });

  return <animated.span>{number.to((n) => Math.floor(n))}</animated.span>;
};
